/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  activationSucceededText: {
    id: "ActivationSucceeded.activationSucceededText",
    defaultMessage: "Congratulations your account have been successfully registered. Launch the application now.",
  },
  activationSucceededButton: {
    id: "ActivationSucceeded.activationSucceededButton",
    defaultMessage: "Lets go",
  },
  activaionInvalid: {
    id: "ActivationFailed.activationInvalid",
    defaultMessage: "Unfortunately activation is failed!",
  },
  activaionInvalidToken: {
    id: "ActivationFailed.activationInvalidToken",
    defaultMessage: "Your token is expired. Please check if your account is already activated. Try to log in.",
  },
  activaionInvalidTokenButton: {
    id: "ActivationFailed.activationInvalidTokenButton",
    defaultMessage: "Send me new link",
  },
  activaionUserNotFound: {
    id: "ActivationFailed.activaionUserNotFound",
    defaultMessage: "This user doesn't exist. Please register a new account.",
  },
  activaionUserNotFoundButton: {
    id: "ActivationFailed.activaionUserNotFoundButton",
    defaultMessage: "Register",
  },
  activationResend: {
    id: "ActivationFailed.ActivationResend",
    defaultMessage: "Resend activation Link",
  }
});

export default MESSAGES;